import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from 'recharts'
import AngledAxisTick from '../AngledAxisTick'
import { CATEGORICAL } from '../../../helpers/chartPalette'
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette'
import ChartDataTable from '../../graphData/ChartDataTable'
import { wideTable } from '../../../helpers/dataHelpers/chartDataTable'

const StackedBarGraph = ({ data }) => {
  // Dynamically pick up every key except 'name' as its own series
  const keys = data.length > 0
    ? Object.keys(data[0]).filter(k => k !== 'name')
    : []

  const colors = CATEGORICAL

  return (
    <>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="name" axisLine={false} tickLine={false} tick={<AngledAxisTick />} interval={0} height={70} />
        <YAxis axisLine={false} tickLine={false} />
        <Tooltip />
        <Legend />
        {keys.map((key, i) => (
          <Bar
            key={key}
            dataKey={key}
            stackId="a"
            fill={colors[i % colors.length]}
          stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
        ))}
      </BarChart>
    </ResponsiveContainer>
    {/* Zelfde reeksen als de staven, voor de kopie. */}
    <ChartDataTable table={wideTable(data, keys, 'Datum')} />
    </>
  )
}

export default StackedBarGraph